import React, { createContext, FC, ReactNode, useContext } from 'react'
import { FormatVersion } from '~/generated/graphql'

type CampaignInputContextValue = {
  formatVersion: FormatVersion
}

const CampaignInputContext = createContext<CampaignInputContextValue | undefined>(undefined)

export const useCampaignInputContext = (): CampaignInputContextValue | undefined => {
  return useContext(CampaignInputContext)
}

type Props = {
  formatVersion: FormatVersion
  children: ReactNode
}

export const CampaignInputProvider: FC<Props> = ({ formatVersion, children }) => {
  return <CampaignInputContext.Provider value={{ formatVersion }}>{children}</CampaignInputContext.Provider>
}
